import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  mb: 1,
};

export const desktopPaper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(1),
  mt: 1,
};
